import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCustomsDeclarationsTableColumns } from './use-customs-declarations-table-columns';
import { CustomsDeclarationsTableContext } from '../../context';

export const useCustomsDeclarationsTable = () => {
  const columns = useCustomsDeclarationsTableColumns();
  const { mergeState } = useContext(CustomsDeclarationsTableContext);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.customsDeclarationsTable?.mergeState) {
      mergeState(location.state.customsDeclarationsTable.mergeState);
    }
  }, [location.state?.customsDeclarationsTable?.mergeState, mergeState]);

  return { columns };
};
